import { render, staticRenderFns } from "./ComprobanteArrendamiento.vue?vue&type=template&id=069b7702&"
import script from "./ComprobanteArrendamiento.vue?vue&type=script&lang=js&"
export * from "./ComprobanteArrendamiento.vue?vue&type=script&lang=js&"
import style0 from "./ComprobanteArrendamiento.vue?vue&type=style&index=0&id=069b7702&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports